import { Pill, Tooltip } from "@/ui";
import type { BindStatus } from "./binds";

/** 通道与客户账号绑定状态的标签（决策 D176、D178）：有说明（没连满时的最近失败原因、未上报的排查提示、在线会话清单）时悬停或聚焦显示，
 * 说明是数组时一项一行；不连上游的通道、HTTP 账号显示横线。 */
export function BindStatusPill({ status }: { status: BindStatus | null }) {
  if (!status) return <>—</>;
  const pill = <Pill tone={status.tone}>{status.label}</Pill>;
  if (!status.detail) return pill;
  const content = Array.isArray(status.detail) ? status.detail.map((line, i) => <div key={i}>{line}</div>) : status.detail;
  return <Tooltip multiline content={content}><span tabIndex={0}>{pill}</span></Tooltip>;
}
